// extracted by mini-css-extract-plugin
export default {"status":"styles_status__lE3sy","inProgress":"styles_inProgress__2ljua","onHold":"styles_onHold__6KWx5","pending":"styles_pending__Hy3xu","approved":"styles_approved__4ndph"};